export const MOBILE_DEVICE_MAX_WIDTH = 480
